import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    isOpen: true
}

export const controlSlide = createSlice({
    name: 'control-sidebar',
    initialState,
    reducers: {
        controlSidebar: (state, action:  PayloadAction<boolean>) => ({
            ...state,
            isOpen: action.payload
        })
    }
})
export const {controlSidebar} = controlSlide.actions;
const {reducer: controlSidebarReducer } = controlSlide;
export default controlSidebarReducer;